module.exports = __webpack_public_path__ + "img/maroon_5_juin2021.7dd312c4.jpg";